import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {getProcessTypeFor, Order, OrderStatusEnum, ProcessType} from "../../../store/state/order.state";
import {ChangeSet} from "../history/order-history.model";

@Component({
    selector: 'order-details',
    templateUrl: './order-details.template.html',
    styleUrls: ['./order-details.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OrderDetailsComponent implements OnInit {

	@Input() order: Order;
	@Input() detailsVisible: boolean = false;
	@Input() editable: boolean = true;
	@Input() collapsable: boolean = true;
	@Input() changeSet: ChangeSet;	// optional
	@Input() translateClientsData: boolean;
	@Input() useOriginalTranslations: boolean;
	@Input() showPriceFactorTooltips: boolean = false;
	@Input() withProductDetails: boolean = true;
	@Input() clientContext: boolean = false;
	@Output() basicInfoChangeRequested: EventEmitter<any> = new EventEmitter<any>();

	ngOnInit(): void {
		this.detailsVisible = this.detailsVisible ? this.detailsVisible :
			(this.clientContext ? this.detailsVisible : this.isTranslation());
	}

	get companyName(): string {
		return this.order.company.name;
	}

	isCompanyNameChanged(): boolean {
		return !!this.changeSet && !!this.changeSet.changes.company.name;
	}

	isRecertification(): boolean {
		return getProcessTypeFor(this.order) === ProcessType.RECERTIFICATION;
	}

	isTranslation(): boolean {
		return this.order.status == OrderStatusEnum.TRANSLATION;
	}
}
